// extracted by mini-css-extract-plugin
module.exports = {"Packaging":"Packaging__Packaging__[hash_base64-5]"};